import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_thumbsup: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-thumbsup" {...rest}>
      <title>praise-thumbsup</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#F8AE41"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <path fill="#386CBB" d="M27.3 69.1h23.8v37.3H27.3z"></path>
      <path
        fill="#FFF"
        d="M57.1 67.6c5.1-1.7 10.1-5.7 12.4-9.5s16-16.7 18.3-24.5 5.9-8.8 10.2-4.4c7.2 7.3-5 26.5-5 26.5 1.4 4.9 28.1-4 28.1 7.3 0 3.1-1.6 3.8-1.6 6.2s4.7 1.8 4.7 6.4-2.9 4.3-2.9 6.5c0 2.1 2.1 1.5 2.1 6.5 0 4.3-4.6 5-4.6 6.8s.7 1.9.7 6.1c0 13.9-48 5.4-62.4 5.4V67.6z"
      ></path>
    </svg>
  );
};
